export default __webpack_public_path__ + "69d604b099e2f040b5d7118efea9e3a1.jpg";